import React, { Component } from 'react';
import * as WizardClasses from './WizardClasses'
import { connect } from 'react-redux';
import ReactMarkdown from 'components/Markdown/Markdown';
import {
  TextInput,
  TextArea,
  Select,
  RadioInput,
  Checkbox,
  ConfirmFields,
  DateInput,
  FullName,
  NameOrg,
  TimeInput
} from './fieldComponents/Form'
import FileUpload from './fieldComponents/FileUpload';
import AddressBlock from './fieldComponents/AddressBlock';
import Repeater from './fieldComponents/Repeater';
import ServerOptions from './fieldComponents/ServerControls';
import RegisteredAgentSearch from './fieldComponents/RegisteredAgentSearch';
import NameQualifiedOrg from './fieldComponents/NameQualifiedOrg';
import SearchControl from './fieldComponents/SearchControl';
import Summary from './fieldComponents/Summary';
import UploadAccumulator from './fieldComponents/UploadAccumulator';
import UploadAndSubmit from './fieldComponents/UploadAndSubmit';
import Signatures from './fieldComponents/Signatures'
import FormationLocale from './fieldComponents/FormationLocale'
import EntityNameSearch from './fieldComponents/EntityNameSearch'
import DateRange from './fieldComponents/DateRange'
import DataTable from './fieldComponents/DataTable'
import Paragraph from './fieldComponents/Paragraph'
import UCCSearch from './fieldComponents/UCCSearch'
import LocalSelect from './fieldComponents/LocalSelect'
import MultiComplete from './fieldComponents/MultiComplete'
import EFSCropPicker from './fieldComponents/EFSCropPicker'
import { validateAndSetFieldAttributes } from './WizardActions';
import { maskValue } from './validate';
import ReactTooltip from 'react-tooltip'
import { notNullOrUndefined } from 'utilities'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'
import RevertIcon from '@tecuity/sos-icons/react/revert'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import FieldTooltip from './Tooltip'
import resolveLogic from './resolveFieldLogic'
import '../../common/css/loaders.css'

class Field extends Component{
  handleFieldChange = (value, e, extraPayload, overrideSetValue, options={}) => {
    value = maskValue(value, this.props.field.mask);
    this.props.validateAndSetFieldAttributes({fieldId: this.props.field.fieldId, event: "onChange", value, setValue: true, extraPayload});
    if(options.triggerOnAdvanceValidation){
      this.props.validateAndSetFieldAttributes({fieldId: this.props.field.fieldId, event: "onAdvance", value, setValue: false, extraPayload});
    }
  }
  handleFieldBlur = (value, e, extraPayload, overrideSetValue, options={}) => {
    this.props.validateAndSetFieldAttributes({fieldId: this.props.field.fieldId, event: "onBlur", value, setValue: overrideSetValue ? true : false, extraPayload, options});
  }
  getField = field => {
    const { fields, isFirst, readOnly, correctionMode } = this.props;
    const events = {
      onChange: this.handleFieldChange,
      onBlur: this.handleFieldBlur,
    }
    let isValid = this.props.isValid === true || this.props.isValid === false ? this.props.isValid : field.isValid;
    const value = this.props.value ? this.props.value : field.value;
    const attributes = {
      value,
      validityClass: getValidityClass(field.isValid),
      isValid,
      isFirst,
      disabled: readOnly ? true : ((correctionMode && field.disabledDuringCorrection) || field.disabled)
    }
    switch(this.props.type ? this.props.type : field.type){
      case "text":
      case "number":
        return <TextInput {...events} {...field} {...attributes} />
      case "textArea":
        return <TextArea {...events} {...field} {...attributes} />
      case "select":
        return <Select {...events} {...field} {...attributes} />
      case "radio":
        return <RadioInput {...events} {...field} {...attributes} />
      case "checkbox":
        return <Checkbox {...events} {...field} {...attributes} />
      case "dependentSelect":
        const selectedOption = field.options.find(option => option.value == field.value)
        return (
          <div>
                <Select {...events} {...field} options={field.options} {...attributes} />
            {
              selectedOption ?
              selectedOption.fields.map((subFieldId) => {
                if(fields[subFieldId]){
                  return fields[subFieldId].active && <div className="dependent-field" key={subFieldId}><SubField field={fields[subFieldId]} key={subFieldId} /></div>
                }else{
                  console.warn(`Attempted to render subfield of DependentSelect "${field.label}" with subFieldId ${subFieldId}, but got null.`)
                  return null;
                }
              })
              :
              null
            }
          </div>)
      case "dependentRadio":
        let selectedIndex = field.options.findIndex(option=>(option.value.toString() === field.value.toString()))
        return (
          <div>
            <RadioInput {...events} {...field} {...attributes} />
            {
              selectedIndex >= 0 ?
              field.options[selectedIndex].fields.map((subFieldId) => {
                if(fields[subFieldId]){
                  return fields[subFieldId].active && <div className="dependent-field" key={subFieldId}><SubField field={fields[subFieldId]} key={subFieldId} /></div>
                }else{
                  console.warn(`Attempted to render subfield of DependentRadio "${field.label}" with subFieldId ${subFieldId}, but got null.`)
                  return null
                }
              })
              :
              null
            }
          </div>)
      case 'dependentCheck':
        let fieldGroup = field.value ? "checkedFields" : "uncheckedFields";
        return (
          <div>
            <Checkbox {...events} {...field} {...attributes} />
            {
              field[fieldGroup].map((subFieldId) => {
                if(fields[subFieldId]){
                  return fields[subFieldId].active && <div className="dependent-field" key={subFieldId}><SubField field={fields[subFieldId]} key={subFieldId} /></div>
                }else{
                  console.warn(`Attempted to render subfield of DependentCheck "${field.label}" with subFieldId ${subFieldId}, but got null.`)
                  return null;
                }
              })
            }
          </div>)
      case "confirmFields":
        return <ConfirmFields {...events} {...field} {...attributes} />
      case "addressBlock":
        return <AddressBlock {...events} {...field} {...attributes} />
      case "repeater":
        return <Repeater {...events} {...field} {...attributes}/>
      case "paragraph":
        return <Paragraph {...events} {...field} {...attributes} />
      case 'DataTable':
        return <DataTable {...events} {...field} {...attributes} />
      case "serverSelect":
      case "serverRadio":
        return <ServerOptions {...events} {...field} {...attributes} />
      case "date":
        return (
          <div className='row'>
            <div className='col-lg-4 col-md-7 col-sm-12'>
              <DateInput {...events} {...field} {...attributes} className={"w" + field.width.replace('%', '')} />
            </div>
          </div>
        )
      case "DateRange":
        return <DateRange {...events} {...field} {...attributes} />
      case "TimeInput":
        return <TimeInput {...events} {...field} {...attributes} />
      case "file":
        return <FileUpload {...events} {...field} {...attributes} />
      case "registeredAgentSearch":
        return <RegisteredAgentSearch {...events} {...field} {...attributes} />
      case "Summary":
        return <Summary {...field} />
      case "FullName":
        return <FullName {...events} {...field} {...attributes} />
      case "NameOrg":
        return <NameOrg {...events} {...field} {...attributes} />
      case "NameQualifiedOrg":
        return <NameQualifiedOrg {...events} {...field} {...attributes} />
      case "UploadPlaceholder":
        return <div></div>
      case "UploadAccumulator":
        return <UploadAccumulator {...events} {...field} {...attributes} />
      case "UploadAndSubmit":
        return <UploadAndSubmit {...events} {...field} {...attributes} />
      case "SearchControl":
        return <SearchControl {...events} {...field} {...attributes} />
      case "Signatures":
        return <Signatures {...events} {...field} {...attributes} />
      case "FormationLocale":
        return <FormationLocale {...events} {...field} {...attributes} />
      case "EntityNameSearch":
        return <EntityNameSearch {...events} {...field} {...attributes} />
      case "UCCSearch":
        return <UCCSearch {...events} {...field} {...attributes} />
      case "LocalSelect":
        return <LocalSelect {...events} {...field} {...attributes} />
      case "MultiComplete":
        return <MultiComplete {...events} {...field} {...attributes} />
      case "ServerMultiComplete":
        return <ServerOptions {...events} {...field} {...attributes} />
      case "EFSCropPicker":
        return <EFSCropPicker {...events} {...field} {...attributes} />
      default:
        console.warn("Looks like you attempted to render an invalid field. Check the \"type\" attribute to make sure that it returns a valid field type.", field)
        return <div>Not a valid field</div>
    }
  }
  revert = () => {
    // console.log(this.props);
    this.handleFieldChange(this.props.originalValue, {}, {})
  }
  getVisibilityFromConditions = () => {
    const conditions = this.props.field.conditions;
    if(conditions && !this.props.bypassConditionCheck){
      return resolveFieldConditions(conditions, this.props.fields, this.props.field.conditionsOperator)
    }else{
      return true;
    }
  }
  compareValues = (originalValue, currentValue) => {
    return WizardClasses[this.props.field.fieldClass].compareValues(originalValue, currentValue)
  }
  render(){
    const { originalValue, showDiff, preview, field, bypassLogicResolution } = this.props
    let calculatedField = bypassLogicResolution ? field : resolveLogic(field, { isRenderingFieldInRepeater: field.parent.type === "REPEATER" })
    const {
      active,
    	label,
    	tooltip,
    	ownsLabel,
    	hideLabel,
      ownsTooltip,
      hideTooltip,
    	type,
    	required,
    	errorMessage,
    	description,
    	value,
    	parent,
    	delegateErrorsToChildren,
      excludeFromDiff,
      alwaysShowDescription,
      infoMessage,
      allowInfoMessage,
      disabled
    } = calculatedField
    const currentValueIsDifferent = !showDiff
    	? false
    	: excludeFromDiff ? false : this.compareValues(originalValue, this.props.value ? this.props.value : value)
    return(
        <FieldErrorBoundary field={field}>
          {
            this.getVisibilityFromConditions() && active &&
            <DumbField
              fieldId={field.fieldId}
            	label={label}
              tooltip={tooltip}
              ownsLabel={ownsLabel}
              ownsTooltip={ownsTooltip}
            	hideLabel={hideLabel}
              hideTooltip={hideTooltip}
            	type={type}
            	required={required ? required : required}
            	description={description}
            	errorMessage={errorMessage}
            	currentValueIsDifferent={currentValueIsDifferent && showDiff && parent.type !== 'REPEATER' && !preview}
              revert={this.revert}
              delegateErrorsToChildren={delegateErrorsToChildren}
              alwaysShowDescription={alwaysShowDescription}
              infoMessage={allowInfoMessage && infoMessage}
              disabled={disabled}
            >
            	{this.getField(calculatedField)}
            </DumbField>
          }
        </FieldErrorBoundary>
    )
  }
}
export default connect(
  (state, props)=>({
    fields: state.wizard.wizard.fields,
    hasOriginalValue: Object.hasOwnProperty(state.wizard.diff.original),
    originalValue: notNullOrUndefined(props.originalValue) ? props.originalValue : state.wizard.diff.originalByFieldId[props.field.fieldId],
    mode: state.wizard.mode,
    preview: state.wizard.preview,
    showDiff: state.wizard.showDiff,
    readOnly: state.wizard.readOnly,
    correctionMode: state.wizard.correctionMode
  }),
  {validateAndSetFieldAttributes}
)(Field)

export const DumbField = ({
  children,
  type,
  required,
  label = '',
  tooltip,
  description,
  errorMessage,
  ownsLabel,
  hideLabel,
  ownsTooltip,
  hideTooltip,
  className = '',
  currentValueIsDifferent,
  revert,
  delegateErrorsToChildren,
  infoMessage,
  alwaysShowDescription,
  fieldId = '',
  disabled
}) => {
  const renderedTooltip = tooltip !== '' && tooltip && !hideTooltip && !ownsTooltip ? <FieldTooltip tooltip={tooltip} /> : null;
  return (
  <div className={`field ${currentValueIsDifferent ? 'changed' : ''} ${className}`}>
    {currentValueIsDifferent && !disabled ? (
      <button
        className="field-revert"
        data-for={`revert-${fieldId}`}
        data-tip="Revert"
        onClick={revert}
        type="button"
      >
        <RevertIcon />
        <ReactTooltip effect="solid" place="left" id={`revert-${fieldId}`} />
      </button>
    ) : null}
    {
      !ownsLabel && !hideLabel ? (
        <label className={'field-label '} htmlFor={fieldId ? `field-${fieldId}` : undefined}>
          <span className={`label-text `}>
            {label}
            {required && label !== '' ? (
              <span className="required" aria-hidden={true}>
                *
              </span>
            ) : null}
          </span>
          {renderedTooltip}
        </label>
      ) : renderedTooltip
    }
    {description !== '' && description && (!hideLabel || alwaysShowDescription) ? (
      <ReactMarkdown
        className="description"
        source={description}
        escapeHtml
        id={fieldId ? `field-description-${fieldId}` : undefined}
      />
    ) : null}
    {children}
    {errorMessage !== '' && Array.isArray(errorMessage) && !delegateErrorsToChildren
      ? errorMessage.map((error, i) => {
          if (error !== '') {
            return (
              <p
                role="alert"
                key={i}
                className="field-error animated fadeIn fast-animation"
                id={fieldId ? `field-error-${fieldId}` : undefined}
              >
                {error}
              </p>
            )
          } else return null
        })
      : null}
    {infoMessage && !delegateErrorsToChildren && <InfoMessage>{infoMessage}</InfoMessage>}
  </div>
)}


export const getValidityClass = (isValid) => {
  if(isValid === false){
    return "invalid"
  }else if(isValid === true){
    return "valid"
  }else{
    return ""
  }
}

class SubField extends Component{
  render(){
    return(
      <Field {...this.props} />
    )
  }
}
SubField = connect(
  (state, props)=>({
    fields: state.wizard.wizard.fields,
    originalValue: state.wizard.diff.originalByFieldId[props.field.fieldId],
    mode: state.wizard.mode,
    readOnly: state.wizard.readOnly
  }),
  {validateAndSetFieldAttributes}
)(SubField)

export const InfoMessage = ({ children }) => (
  <div className="info-message">
    <div className="icon-wrapper" />
    {children}
  </div>
)

class FieldErrorBoundary extends React.Component {
  state = { hasError: false }
  componentDidCatch = (error, info) => {
    this.setState({ hasError: true })
    console.error(
      "Something went wrong while trying to render the following component: ",
      this.props.field
    )
  }
  render() {
    const { children } = this.props
    return this.state.hasError ? (
      <div className="__crash-error">
        <CrossIcon /> Something went wrong with this field.
      </div>
    ) : (
      children
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/Field.js